import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { CookieService } from 'src/app/customServices/cookie.service';
import { CountrySelectorService } from 'src/app/customServices/country-selector.service';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';

@Component({
  selector: 'app-kb-header-language',
  templateUrl: './kb-header-language.component.html',
  styleUrls: ['./kb-header-language.component.scss'],
  standalone: false
})
export class KbHeaderLanguageComponent {
  languageIsoCode: string;
  isLoggedIn: any;
  platformId = inject(PLATFORM_ID);
  subscription = new Subscription();


  constructor(
    public countrySelectorService: CountrySelectorService,
    private authService: AuthService,
    public cookieService: CookieService,
    public langService: KBLanguageService,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit() {
    this.subscription.add(this.langService.getActive().subscribe((data) => {
      switch (data) {
        case 'fr_CA':
          this.languageIsoCode = 'fr'
          break;
        case 'es_MX':
          this.languageIsoCode = 'es'
          break;
        default:
          this.languageIsoCode = data;
          break;
      }
      this.cdr.detectChanges();
    }));


    this.subscription.add(this.authService
      .isUserLoggedIn()
      .pipe(distinctUntilChanged())
      .subscribe((data) => {
        this.isLoggedIn = data;
      }));
  }

  languageChange(currentLang, langCode, baseSite, event: Event) {
    if (this.isLoggedIn) {
      const cookiesData = {
        displayIsoCodeNA: currentLang,
        languageIsoCodeNA: langCode,
      };
      this.cookieService.setCookies(cookiesData);
    }
    this.langService.setActive(langCode);

    //Add active/Remove
    const targetElement = event.target as HTMLElement;
    targetElement.classList.add('lang-Active');
    if (isPlatformBrowser(this.platformId)) {
      const allElements = document.querySelectorAll('.lang-Active');
      allElements.forEach((element) => {
        if (element !== targetElement) {
          element.classList.remove('lang-Active');
        }
      });
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
